module.exports = __webpack_public_path__ + "img/Logo on transparent background.0b1438ce.png";